/**
 * @fileoverview Connect caller-owned chart data to a Chart.js instance with React-owned lifetime. The wrapper owns instance replacement and destruction; the workspace owns query scope, aggregation meaning, and refresh decisions. Chart cleanup releases presentation resources rather than cancelling the underlying data workflow.
 */

import React, { useRef, useEffect } from 'react'
import { Chart } from 'chart.js/auto'



function ChartCanvas({ type = 'bar', data, options, plugins, style }) {
    const canvasRef = useRef(null)
    const chartRef = useRef(null)

    useEffect(

    () => {
        if (!canvasRef.current || !data) return

        // Destroy previous chart instance
        if (chartRef.current) {
            chartRef.current.destroy()
        }

        chartRef.current = new Chart(canvasRef.current, {
            type,
            data,
            plugins,
            options: {
                responsive: true,
                maintainAspectRatio: true,
                ...options
            }
        })

        return () => {
            if (chartRef.current) {
                chartRef.current.destroy()
                chartRef.current = null
            }
        }
    }, [type, data, options, plugins])

    return <canvas ref={canvasRef} style={style} />
}

export default ChartCanvas
